import { Time } from '@angular/common';
import { LiveRouteType } from './live-route-type';
import { LiveRouteStatus } from './live-route-status';
import { PickupType } from './pickup-type';
import { MatTableDataSource } from '@angular/material/table';
import { AddressGroup } from './dto-address-group';

export class LiveRouteConsol {
  LiveRouteID: number;
  RouteDate: Date;
  ExpDate: Date;
  ShippingID: number;
  ConsolID: number;
  PickupID: number;
  PickupType: PickupType;
  Latitude: number;
  Longitude: number;
  NoStop: number;
  ForecastedArrivalTime: Time;
  ForecastDisplayFormat: String;
  InsertDate: Date;
  UpdateDate: Date;
  LastLoadDate: Date;
  LastSaveDate: Date;
  RouteID: number;
  CustomerID: number;
  CustomerName: string;
  Type: LiveRouteType;
  Status: LiveRouteStatus;
  Address1: string;
  Address2: string;
  Priority: any;
  City: string;
  Name: string;
  PostalCode: string;
  AccountID: string;
  Note: string;
  NbrDataReceived: number;
  NbrScannedByConveyor: number;
  NbrScannedByTpsl: number;
  ScanConveyorCompleted: boolean;
  ScanTpslCompleted: boolean;
  COD: boolean;
  CODAmount: number;
  CODType: string;
  FreezeProtection: boolean;
  AAF: boolean;
  SpecialService: boolean;
  Reference: string;
  Signature_Not_Required: boolean;
  PartialDeliveryAllowed: boolean;
  ParcelNb: number;
  ParcelIDs: number[];
  Parcels: LiveRouteConsol[];
  NatFlex: boolean;
  StatusIcon: string;
  StatusIconClass: string;
  GroupId: number;
  Grouped: boolean;
  GroupItem: AddressGroup[];
  GroupItemDatasource: MatTableDataSource<AddressGroup>;
  PendingExceptionId: number;
}
